import { render, staticRenderFns } from "./feed-create.vue?vue&type=template&id=7042120d&scoped=true&"
import script from "./feed-create.vue?vue&type=script&lang=js&"
export * from "./feed-create.vue?vue&type=script&lang=js&"
import style0 from "./feed-create.vue?vue&type=style&index=0&id=7042120d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7042120d",
  null
  
)

export default component.exports